import Plugin from '../core/Plugin';
import * as SelectionUtils from '../SelectionUtils';

/**
 * AlignmentPlugin - Handles text alignment (left, center, right)
 */
class AlignmentPlugin extends Plugin {
  constructor(editor, options = {}) {
    super(editor, options);
    this.name = 'Alignment';
  }

  getToolbarButtons() {
    return [
      {
        name: 'alignment',
        buttons: [
          {
            command: 'justifyLeft',
            label: '<i class="fa-solid fa-align-left"></i>',
            title: 'Align Left',
          },
          {
            command: 'justifyCenter',
            label: '<i class="fa-solid fa-align-center"></i>',
            title: 'Align Center',
          },
          {
            command: 'justifyRight',
            label: '<i class="fa-solid fa-align-right"></i>',
            title: 'Align Right',
          },
        ],
      },
    ];
  }

  executeCommand(command) {
    switch (command) {
      case 'justifyLeft':
        SelectionUtils.alignText('left');
        break;
      case 'justifyCenter':
        SelectionUtils.alignText('center');
        break;
      case 'justifyRight':
        SelectionUtils.alignText('right');
        break;
    }
  }

  getMetadata() {
    return {
      name: 'Text Alignment',
      version: '1.0.0',
      description: 'Provides text alignment options (left, center, right)',
      author: 'AtlaraFirm',
    };
  }
}

export default AlignmentPlugin;
